


<div class="content-send text-center">
  <div class="icons text-primary">
    <span *ngIf="getIsRevision()" class="icon-reload"></span>
    <span *ngIf="getIsFinalSubmission() || getIsSubmitToSubscriber()" class="icon-loading"></span>
  </div>
  <div class="mb-4">
    <h5 class="text-gray-700">{{ 'PrestacoesMorte.StepSubmit.MessageBeforeSubmit' | translate}}</h5>
    <br />
    <br />
    <!--<h5 class="text-gray-700">{{ 'PrestacoesMorte.StepSubmit.PromptBeforeSubmit' | translate}}</h5>-->

  </div>
  
</div>


